import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { ProfileActionsWidgetItem } from '../../../Widget'
import {
  EMAIL_PROFILE_NAVIGATION_NEXT_ICON_PROPS,
  EMAIL_PROFILE_NAVIGATION_PREVIOUS_ICON_PROPS,
} from '../../Email.constants'

import {
  QA_NAME_EMAIL_PROFILE_ACTIONS_WIDGET_NAVIGATION_RAIL_NEXT,
  QA_NAME_EMAIL_PROFILE_ACTIONS_WIDGET_NAVIGATION_RAIL_PREVIOUS,
} from './EmailProfileActionsWidgetNavigationRail.constants'

function EmailProfileActionsWidgetNavigationRail({
  hasNext,
  hasPrevious,
  onNext,
  onPrevious,
}) {
  const { t } = useTranslation()

  return (
    <>
      <ProfileActionsWidgetItem
        beforeIconProps={EMAIL_PROFILE_NAVIGATION_PREVIOUS_ICON_PROPS}
        disabled={!hasPrevious}
        qaName={QA_NAME_EMAIL_PROFILE_ACTIONS_WIDGET_NAVIGATION_RAIL_PREVIOUS}
        tooltip={t('EmailProfile.ActionsWidgetNavigationPrevTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.left}
        onClick={onPrevious}
      />
      <ProfileActionsWidgetItem
        beforeIconProps={EMAIL_PROFILE_NAVIGATION_NEXT_ICON_PROPS}
        disabled={!hasNext}
        qaName={QA_NAME_EMAIL_PROFILE_ACTIONS_WIDGET_NAVIGATION_RAIL_NEXT}
        tooltip={t('EmailProfile.ActionsWidgetNavigationNextTooltipKey')}
        tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.left}
        onClick={onNext}
      />
    </>
  )
}

export default EmailProfileActionsWidgetNavigationRail
